/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) State Dot Icon component - the
 * 10x10 solid circle shown before the State Tag label on the Asset Summary
 * Card (ION-7392), fixed at 10x10 per Figma regardless of the passed `size`
 * since it is a status dot, not a scalable icon.
 */
export const StateDotIcon = (props: IconProps) => {
  const {iconColor} = useIconDLS(props);
  return (
    <svg width={10} height={10} viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx={5} cy={5} r={5} fill={iconColor} />
    </svg>
  );
};

export default StateDotIcon;
